import script from "./message-abstract-image.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-image.vue?vue&type=script&setup=true&lang=ts"

import "./message-abstract-image.vue?vue&type=style&index=0&id=61e6c880&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e6c880"]])

export default __exports__